import styled from 'styled-components';

export const PaymentSecureInfoWrapper = styled.div`
  max-width: 293px;
  padding-top: 24px;
  padding-bottom: 15px;
  margin: 0 auto;
  font-size: 10px;
  line-height: 14px;
  color: #c1c1c1;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const PaymentSecureInfoWrapperRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  @media screen and (max-width: 300px) {
    flex-direction: row;
    gap: 16px;
    img {
      width: 100px;
    }
    &.cards {
      img {
        width: 50px;
      }
    }
  }
`;
